<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc">
<h1>Table of Contents</h1>
<ol>
<li id="level1-titlepage">
<span href="#/titlepage" title="Link target outside of Sample">Title Page</span>
</li>
<li id="level1-toc">
<a href="#/toc">Table of Contents</a>
</li>
<li id="level1-front3">
<a href="#/front01">Copyright</a>
</li>
<li id="level1-front4">
<a href="#/front02">Dedication</a>
</li>
<li id="level1-front5">
<a href="#/front03">Epigraph</a>
</li>
<li id="level1-front6">
<a href="#/front04">Introduction</a>
</li>
<li id="c01">
<a href="#/c01">The Farm in Lost Nation</a>
</li>
<li id="c02">
<span href="#/c02" title="Link target outside of Sample">Hannibal Rex</span>
</li>
<li id="c03">
<span href="#/c03" title="Link target outside of Sample">The Snow Owl</span>
</li>
<li id="c04">
<span href="#/c04" title="Link target outside of Sample">The Green Mountain Whale</span>
</li>
<li id="c05">
<span href="#/c05" title="Link target outside of Sample">Down the Coat</span>
</li>
<li id="c06">
<span href="#/c06" title="Link target outside of Sample">Upland Game</span>
</li>
<li id="c07">
<span href="#/c07" title="Link target outside of Sample">Lost Nation Calendar</span>
</li>
<li id="c08">
<span href="#/c08" title="Link target outside of Sample">Family Reunion</span>
</li>
<li id="c09">
<span href="#/c09" title="Link target outside of Sample">The Season of the Cluster Flies</span>
</li>
<li id="c10">
<span href="#/c10" title="Link target outside of Sample">Northern Borders</span>
</li>
<li id="level1-back17">
<span href="#/back01" title="Link target outside of Sample">About the Author</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?30179a9d